import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Row extends Component {
  static propTypes = {
    gutters: PropTypes.bool,
    inner: PropTypes.bool,
    alignItems: PropTypes.string,
    alignContent: PropTypes.string,
    justifyContent: PropTypes.string,
    children: PropTypes.any,
    paddingTop: PropTypes.bool
  }

  static defaultProps = {
    inner: false
  }

  render() {
    const {
      children,
      alignItems,
      justifyContent,
      alignContent,
      gutters,
      inner,
      paddingTop
    } = this.props
    const marginVer = inner ? 0 : 8
    const marginHor = 8
    const padTop = paddingTop ? 4 : 0
    let element = React.cloneElement(children, { margin: marginHor, gutters })

    if (Array.isArray(children)) {
      element = children
        .filter(item => item)
        .map((child, key) =>
          React.cloneElement(child, { margin: marginHor, key, gutters })
        )
    }

    return (
      <div
        style={{
          display: 'flex',
          alignItems: alignItems || 'flex-start',
          justifyContent: justifyContent || 'flex-start',
          alignContent: alignContent || 'flex-start',
          margin: `${marginVer * 2}px ${gutters ? -marginHor : 0}px`,
          paddingTop: `${padTop}px`
        }}
      >
        {element}
      </div>
    )
  }
}
